import { amountFormat } from '../../../../util/shared/vue-global';

const formatAmountOrNull = (val) => {
  /*
    note: doing amountFormat on val first since val can be '-3.637978807091713e-12' or null or 0
  */
  const formatAmount = amountFormat(val);
  const amount = ((formatAmount === '0.00') ? null : formatAmount);
  return amount;
};

const mapFundAndDesc = (val) => (val != null ? (`${val.fund || ' '} - ${val.description || ' '}`) : ' ');

export const headersByType = {
  BANKS: [
    { text: 'GL #', value: 'banksMonthlyTransaction.line' },
    { text: 'Bank/Invest/Cash', value: 'bank.bankName' },
    {
      text: 'Balance Per Bank Stmt',
      value: 'banksMonthlyTransaction.balPerBankStatement',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Investment',
      value: 'banksMonthlyTransaction.investment',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Reconcilement',
      value: 'banksMonthlyTransaction.reconcilement',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Adj Bank Balance',
      value: 'banksMonthlyTransaction.adjBankBalance',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'GL Bank Balance',
      value: 'banksMonthlyTransaction.glBankBalance',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Difference',
      value: 'banksMonthlyTransaction.difference',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
  ],
  COLLECTIONS: [
    {
      text: 'Desc',
      value: 'fund',
      formatter: 'customMethod',
      methodDefinition: mapFundAndDesc,
    },
    { text: 'Alt Key', value: 'fund.altKey' },
    {
      text: 'Unapportioned Last Month',
      value: 'collectionMonthlyTransaction.unapportionLastMonth',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Receipts',
      value: 'collectionMonthlyTransaction.receipts',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Tx In',
      value: 'collectionMonthlyTransaction.transferIn',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Tx Out',
      value: 'collectionMonthlyTransaction.transferOut',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Refunds/Pmt Cancelled',
      value: 'collectionMonthlyTransaction.refundsPaymentCancelled',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Total',
      value: 'collectionMonthlyTransaction.total',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Apportioned',
      value: 'collectionMonthlyTransaction.apportioned',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Balance Unapportioned',
      value: 'collectionMonthlyTransaction.balanceUnapportioned',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
  ],
  FUNDS: [
    { text: 'Line', value: 'fundsMonthlyTransaction.line' },
    {
      text: 'Fund',
      value: 'fund',
      formatter: 'customMethod',
      methodDefinition: mapFundAndDesc,
    },
    { text: 'Alt Key', value: 'fund.altKey' },
    {
      text: 'Balance Last Month',
      value: 'fundsMonthlyTransaction.balanceLastMonth',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Apportioned',
      value: 'fundsMonthlyTransaction.apportioned',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Tx In',
      value: 'fundsMonthlyTransaction.transferIn',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Tx Out',
      value: 'fundsMonthlyTransaction.transferOut',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Disbursements',
      value: 'fundsMonthlyTransaction.disbursements',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Official Depository',
      value: 'fundsMonthlyTransaction.od',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Balance',
      value: 'fundsMonthlyTransaction.balance',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
  ],
  OFFICIALDEPOSITORY: [
    { text: 'System', value: '' },
    { text: 'Dept', value: 'odMonthlyTransaction.dept' },
    { text: 'Description', value: 'odMonthlyTransaction.description' },
    {
      text: 'Balance Last Month',
      value: 'odMonthlyTransaction.balanceLastMonth',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Deposits',
      value: 'odMonthlyTransaction.deposits',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Tx In Cancelled',
      value: 'odMonthlyTransaction.transferIn',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Tx Out',
      value: 'odMonthlyTransaction.transferOut',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Vouchers Registered',
      value: 'odMonthlyTransaction.vouchersRegistered',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
    {
      text: 'Balance',
      value: 'odMonthlyTransaction.balance',
      align: 'right',
      formatter: 'customMethod',
      methodDefinition: formatAmountOrNull,
    },
  ],
};

export default headersByType;
